export enum ZpusobDolozeniOpravneni {
	EMAIL = 'EMAIL',
	DATOVA_ZPRAVA = 'DATOVA_ZPRAVA',
	PRILOZIT_DOKUMENTY_ZDE = 'PRILOZIT_DOKUMENTY_ZDE',
	NIC = 'NIC'
}
